import { SingleEnumFilter } from "@/features/common/components/filter/SingleEnumFilter";
import { useRequestQuery } from "@/features/common/hooks/useRequestQuery";
import {
  GenderEnum,
  ModelOrderByWithRelationInput,
  ModelTypeEnum,
  ModelWhereInput,
} from "@/generated/graphql-hooks";

const modelGenderFilterList: {
  label: string;
  value: GenderEnum | ModelTypeEnum;
}[] = [
  { label: "所有KOL", value: undefined },
  // gender
  { label: "女KOL", value: GenderEnum.Female },
  { label: "男KOL", value: GenderEnum.Male },
  // modelType
  { label: "美食", value: ModelTypeEnum.Foodie },
  { label: "親子", value: ModelTypeEnum.Family },
];

export const ModelQuickFilterRow = () => {
  const { query: { where } = {}, setWhere } = useRequestQuery<
    ModelWhereInput,
    ModelOrderByWithRelationInput
  >();

  const onSetFilter = (value?: GenderEnum | ModelTypeEnum) => {
    const { gender, modelTypes, ...rest } = where;

    if (!value) {
      setWhere(rest);
      return;
    }

    const filter = Object.values(GenderEnum).includes(value as GenderEnum)
      ? { gender: { equals: value as GenderEnum } }
      : { modelTypes: { has: value as ModelTypeEnum } };

    setWhere({ ...rest, ...filter });
  };

  const renderSelectedItem = ({
    value: selectedValue,
  }: {
    value: string | number;
  }) => {
    const selectedItemLabel = modelGenderFilterList.find(
      ({ value }) => value === selectedValue,
    )?.label;

    return <span>{selectedItemLabel ?? modelGenderFilterList[0].label}</span>;
  };

  return (
    <SingleEnumFilter
      value={(where?.gender?.equals || where?.modelTypes?.has) ?? undefined}
      options={modelGenderFilterList.map(({ label, value }) => ({
        label,
        value,
      }))}
      onSetFilter={onSetFilter}
      renderChip={renderSelectedItem}
    />
  );
};
